import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { Container, Box } from '@mui/material';
import clsx from 'clsx';
import StyledKSearchWidget, { classes } from './index.styled.js';
import KSearchInput from './KSearchInput/index.js';

var KSearchWidget = function KSearchWidget(_a) {
    var _b;
    var className = _a.className, style = _a.style, title = _a.title, backgroundUrl = _a.backgroundUrl, activeFilters = _a.activeFilters, label = _a.label, sx = _a.sx, backgroundImage = _a.backgroundImage, searchBarBackgroundColor = _a.searchBarBackgroundColor, searchBarTextColor = _a.searchBarTextColor, buttonStyle = _a.buttonStyle, rest = __rest(_a, ["className", "style", "title", "backgroundUrl", "activeFilters", "label", "sx", "backgroundImage", "searchBarBackgroundColor", "searchBarTextColor", "buttonStyle"]);
    return (React__default.createElement(StyledKSearchWidget, { className: clsx("KSearchWidget", className), style: style, sx: sx, role: "search" },
        !!backgroundImage && backgroundImage,
        !backgroundImage && backgroundUrl && (React__default.createElement("img", { className: classes.background, src: backgroundUrl, alt: "", style: { borderRadius: (_b = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _b !== void 0 ? _b : "unset" } })),
        React__default.createElement(Container, { className: classes.container, maxWidth: "md" },
            title,
            React__default.createElement(Box, { className: classes.search },
                React__default.createElement(KSearchInput, __assign({ label: label, backgroundColor: searchBarBackgroundColor, textColor: searchBarTextColor, buttonStyle: buttonStyle }, rest))),
            activeFilters)));
};

export { KSearchWidget as default };
//# sourceMappingURL=index.js.map
